import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, Lock } from "lucide-react";
import { useSubscription } from "@/lib/subscription";
import { useAuth } from "@/lib/auth";

/**
 * Wraps children behind a subscription paywall.
 * Admin role bypasses all gates.
 */
export default function FeatureGate({ feature, children, blurb, title }) {
  const sub = useSubscription();
  const { user } = useAuth();
  if (user?.role === "admin") return <>{children}</>;
  if (sub.features?.[feature]) return <>{children}</>;
  return (
    <div className="border border-dashed border-[#d4a574]/40 rounded-lg bg-[#241d16] p-8 text-center" data-testid={`feature-gate-${feature}`}>
      <div className="w-14 h-14 rounded-full bg-[#1c1712] border border-[#d4a574] flex items-center justify-center mx-auto mb-4">
        <Lock size={20} className="text-[#d4a574]" />
      </div>
      <div className="text-[10px] uppercase tracking-[0.2em] text-[#d4a574] font-semibold mb-2">Premium Feature</div>
      <h3 className="font-display text-2xl font-bold mb-2">{title || "Upgrade to unlock"}</h3>
      <p className="text-[13px] text-[#b8ac96] max-w-md mx-auto mb-5">{blurb || "This feature is available on Broker, Enterprise, and Institutional plans."}</p>
      <Link to="/pricing" data-testid={`gate-upgrade-${feature}`} className="inline-flex items-center gap-2 px-5 py-2.5 rounded bg-[#d4a574] text-[#14100c] font-semibold text-[13px] hover:bg-[#e8b988]">
        <Sparkles size={14} /> View Plans
      </Link>
    </div>
  );
}
